import { PageShell } from '@/components/ui/PageShell';
import { EliteCard } from '@/components/ui/EliteCard';
import { Users } from 'lucide-react';
import { useRoleStore } from '@/store/roleStore';
import { useAuthStore } from '@/store/authStore';
import { useEffect } from 'react';

export function TeamDashboard() {
    const { profile } = useAuthStore();
    const { sharedAthletes, teamDashboardStats, fetchCoachData } = useRoleStore();

    useEffect(() => {
        if (profile?.id) {
            fetchCoachData(profile.id);
        }
    }, [profile?.id, fetchCoachData]);

    return (
        <PageShell title="Team HQ" subtitle="Coach Dashboard">
            <div className="space-y-6">
                <EliteCard className="flex items-center gap-4 p-5">
                    <Users className="text-gold-500 w-8 h-8" />
                    <div>
                        <h3 className="text-white font-black text-xl">{teamDashboardStats?.totalAthletes || 0}</h3>
                        <p className="text-text-muted text-[10px] uppercase font-bold tracking-widest">Active Roster</p>
                    </div>
                </EliteCard>

                <h2 className="text-white font-black uppercase tracking-widest text-sm pt-4">Roster</h2>
                <div className="grid gap-3">
                    {sharedAthletes.length === 0 ? (
                        <div className="text-center py-8 text-text-muted text-sm border border-white/5 rounded-2xl bg-bg-surface/50">
                            No athletes shared with you yet. Give your invite token to a parent.
                        </div>
                    ) : (
                        sharedAthletes.map(athlete => (
                            <EliteCard key={athlete.id} className="p-4 flex items-center gap-4">
                                <div className="w-12 h-12 rounded-full bg-white/5 flex items-center justify-center text-xl">
                                    {athlete.avatar || '🤼'}
                                </div>
                                <div className="flex-1">
                                    <h3 className="text-white font-bold">{athlete.name}</h3>
                                    <p className="text-[10px] text-text-muted uppercase tracking-widest font-bold">
                                        {athlete.level} • {athlete.experienceYears} Years Exp
                                    </p>
                                </div>
                            </EliteCard>
                        ))
                    )}
                </div>
            </div>
        </PageShell>
    );
}
